const API_URL = "https://zpanel.zentragroup.cl/app/api";

async function parseJsonResponse(response, emptyMessage) {
  const text = await response.text();

  if (!text) {
    throw new Error(emptyMessage || "Respuesta vacia del servidor.");
  }

  try {
    return JSON.parse(text);
  } catch {
    throw new Error("Respuesta invalida del servidor.");
  }
}

export async function loginCliente(rut) {
  const response = await fetch(`${API_URL}/login_cliente.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rut }),
  });

  return parseJsonResponse(response, "Login sin respuesta del servidor.");
}

export async function getClienteFull(clienteId) {
  const response = await fetch(
    `${API_URL}/cliente_full.php?cliente_id=${encodeURIComponent(clienteId)}`
  );

  return parseJsonResponse(response, "Perfil sin respuesta del servidor.");
}
